import React, { useState, useEffect, useImperativeHandle, useMemo, useCallback, ReactNode, useRef, forwardRef, useContext } from "react";
import classnames from 'classnames';
import './ByzzerChip.scss';

export type ByzzerChipProps = {
    className?: string;
    children?: ReactNode;
    label?: ReactNode;
    onClick?: () => void;
    showClearIcon?: boolean;
}


export const ByzzerChip = ({
    label,
    children = label,
    className,
    onClick,
    showClearIcon,
    ...props
}: ByzzerChipProps) => {

    const baseClassName = 'byzzer-chip';

    function handleClick() {
        onClick?.();
    }

    const isClickable = Boolean(onClick || showClearIcon);

    return (
        <div className={classnames(baseClassName, className, {
            [`${baseClassName}--clickable`]: isClickable
        })} onClick={handleClick}>
            {typeof children === 'string' ? (
                <span className={classnames(`${baseClassName}__text-content`)}>
                    <span>{children}</span> 
                    {isClickable && showClearIcon && (
                        <span className={classnames(`${baseClassName}__text-content-clear`)}/>
                    )}
                </span> 
            ) : children}
        </div>
    );

};

export default ByzzerChip;

ByzzerChip.displayName = 'ByzzerChip';